import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import Auth from '../auth'
import settings from '../settings'

import Popup from '../components/Popup'

const PayPalReactButton = window.paypal.Button.driver('react', {React, ReactDOM});


export default class PayPalButton extends Component {
  render() {
    const client = {
      [settings.PAYPAL_CLIENT]: settings.PAYPAL_KEY
    }

    const style = {
      label: 'pay',
      size:  'responsive',
      shape: 'rect',
      tagline: false
    }

    const payment = (data, actions) => {
      const { plan, promoCode } = this.props
      const token = Auth.getToken()

      // Load deault value for price and description if they weren't passed as props.
      const price = this.props.price || settings.PLANS[plan].price
      const description = this.props.description || settings.PLANS[plan].description

      return actions.payment.create({
        payment: {
          transactions: [
            {
              description: description,
              amount: {
                total: price,
                currency: 'USD'
              },
              custom: JSON.stringify({ plan, token, code: promoCode }),
            }
          ]
        },
        experience: {
          input_fields: {
            no_shipping: 1
          }
        }
      })
    }

    const onClick = () => {
      const token = Auth.getToken()
      if (!token) {
        this.props.history.push('/login')
        return
      }
    }

    const onAuthorize = (data, actions) => {
      return actions.payment.execute().then(response => {
        this.props.displayMessage(
          <div>
            <span> Payment completed! </span> <br/>
            <span> We are processing your order, you will receive an email shortly. </span>
          </div>
        )
      })
    }

    return (
      <div className="paypal-btn">
        <PayPalReactButton
          env={settings.PAYPAL_CLIENT}
          client={client}
          style={style}
          payment={payment}
          commit={true}
          onClick={onClick}
          onAuthorize={onAuthorize}
        />
        <Popup ref={r => this.popup = r} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PaypalButton.js